import { render } from "./LocationsBuenaPark.vue?vue&type=template&id=c09b5662"
import script from "./LocationsBuenaPark.vue?vue&type=script&lang=js"
export * from "./LocationsBuenaPark.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__